
import React from 'react';
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';
import { useContext } from 'react';
import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Polyline, Popup, Circle, Rectangle, Polygon, useMapEvent, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});



const Mapfunction = () => {
    const context = useContext(AdminContext);
    const [id, setId] = useState("");
    const { CreateMapCoordinateforProposal } = context;
    const nav = useNavigate();

    const [clickPositions, setClickPositions] = useState([]);
    const [FetchedCoordinates, setFetchedCoordinates] = useState([]);
    const [typeofConstruction, setTypeofConstruction] = useState("Road");
    const [Creator, setCreator] = useState("District");

    const MapClickHandler = () => {
        useMapEvents({
            click(e) {
                const { lat, lng } = e.latlng;
                if (clickPositions.length < 2) {
                    setClickPositions([...clickPositions, [lat, lng]]);
                } else {
                    // Reset if already 2 points
                    setClickPositions([[lat, lng]]);
                }
            },
        });
        return null;
    }


    let polygonPositions = [];

    if (clickPositions.length === 2) {
        const startPosition = clickPositions[0];
        const endPosition = clickPositions[1];

        // Calculate direction and perpendicular vectors
        const dx = endPosition[1] - startPosition[1];
        const dy = endPosition[0] - startPosition[0];
        const length = Math.sqrt(dx * dx + dy * dy);
        const ux = -dy / length;
        const uy = dx / length;

        // Calculate polygon corners
        const roadWidth = 0.0002; // adjust width
        const corner1 = [startPosition[0] + ux * 0.0002, startPosition[1] + uy * 0.0006];
        const corner2 = [startPosition[0] - ux * 0.0000, startPosition[1] - uy * 0.0014];
        const corner3 = [endPosition[0] - ux * 0.0003, endPosition[1] - uy * 0.0009];
        const corner4 = [endPosition[0] + ux * 0.0000, endPosition[1] + uy * 0.0009];
        polygonPositions = [corner1, corner2, corner3, corner4];
    }



    const fetchCoordinatesfromtable = async () => {
        try {
            let res = await CreateMapCoordinateforProposal("FetchAllCoordinatefromTable");
            console.log(res);
            setFetchedCoordinates(res);

        }
        catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        fetchCoordinatesfromtable();
    }, []);


    const SubmitCoordinateSelected = async () => {
        console.log(clickPositions);
        if (clickPositions.length === 2) {
            const payload = {
                start: clickPositions[0],
                end: clickPositions[1],
                polygon: polygonPositions,
                WorkName: id,
                typeofConstruction: typeofConstruction,
                createdBy: Creator
            };

            try {
                const res = await CreateMapCoordinateforProposal("InsertSelectedCoordinateinTable", payload);
                const { status, message } = res;
                if (status == "ok") {
                    alert(message);
                }
                else if (status == "clear") {
                    sessionStorage.removeItem('createProposalForm');
                    alert(message);
                }

                if (Creator == "State") {
                    nav(`/AdminDashboard/CreateProposalStatewise`);
                }
                else {
                    nav(`/AdminDashboard/CreateProposal`);
                }

            } catch (err) {
                console.error("Error sending coordinates:", err);
                sessionStorage.removeItem('createProposalForm');
                if (Creator == "State") {
                    nav(`/AdminDashboard/CreateProposalStatewise`);
                }
                else {
                    nav(`/AdminDashboard/CreateProposal`);
                }
            }
        }
        else {
            alert("You have not Selected Area !!!")
        }
    }


    const CancelMapSubmission = () => {
        const shouldclose = window.confirm("Are you Sure ?");
        if (shouldclose) {
            alert("Map Cancelled !!");
            if (Creator == "State") {
                nav(`/AdminDashboard/CreateProposalStatewise`);
            }
            else {
                nav(`/AdminDashboard/CreateProposal`);
            }
        }
    }


    const ResetClickPoint = () => {
        setClickPositions([]);
    }


    // stypoe

    const SatelliteLayerSwitcher = () => {
        const [isSatellite, setIsSatellite] = useState(false);
        const map = useMapEvents({
            zoomend: () => {
                const zoom = map.getZoom();
                setIsSatellite(zoom >= 17); // Use satellite when zoom >= 17
            }
        });

        return (
            <>
                {!isSatellite && (
                    <TileLayer
                        attribution='&copy; OpenStreetMap contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        maxZoom={22}
                    />
                )}
                {isSatellite && (
                    <TileLayer
                        attribution="Map data &copy; Google"
                        url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
                        maxZoom={22}
                    />
                )}
            </>
        );
    };


    const handleBack = () => {
        const shouldclose = window.confirm("Are you Sure ?");
        if (shouldclose) {
            alert("Map Cancelled !!");

            if (Creator == "State") {
                nav(`/AdminDashboard/CreateProposalStatewise`);
            }
            else {
                nav(`/AdminDashboard/CreateProposal`);
            }
        }
    }


    useEffect(() => {
        const savedFormData = sessionStorage.getItem('createProposalForm');
        if (savedFormData) {
            let savedData = JSON.parse(savedFormData);
            const { WorkName, Type } = savedData;
            setId(WorkName);
            setCreator(Type);
        }
    }, [])

    return (
        <>

            {/* <div style={{ height: '500px', width: '100%' }}>
                <MapContainer center={[18.5615, 73.7685]} zoom={15} style={{ height: '100%', width: '100%' }}>
                    <TileLayer
                        attribution='&copy; OpenStreetMap contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={startPosition}>
                        <Popup>Start Point</Popup>
                    </Marker>
                    <Marker position={endPosition}>
                        <Popup>End Point</Popup>
                    </Marker>
                    <Polyline positions={positions} color="blue" />

                    <Polygon
                        positions={polygonPositions}
                        pathOptions={{ color: 'green', weight: 2, fillOpacity: 0.4 }}
                    >
                        <Popup>Road Blocked - No Access</Popup>
                    </Polygon>
                </MapContainer>
            </div> */}

            <div className="col-12" style={{ height: "90vh", overflowY: "scroll", scrollBehavior: "smooth" }}>
                <div className="col-11 m-auto my-3">
                    <div className="row">
                        <div className="col-3">
                            <button className="btn btn-outline-secondary d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill shadow-sm back-button"
                                onClick={() => handleBack()}
                            >
                                <span style={{ fontSize: "1.2rem" }}>&larr;</span>
                                <span style={{ fontWeight: "500" }}>Back</span>
                            </button>
                        </div>

                        <div className="col-9">
                            <div className="row">
                                <div className="col-4">
                                    <p className='fw-bold'>
                                        Type of Construction :
                                    </p>
                                </div>

                                <div className="col-6">
                                    <select name="" id="" value={typeofConstruction} onChange={(e) => setTypeofConstruction(e.target.value)}>
                                        <option value="Road">Road Construction</option>
                                        <option value="Metro">Metro Construction</option>
                                        <option value="Water">Water Line Construction</option>
                                        <option value="Drainage">Drainage Line Construction</option>
                                    </select>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>



                <div className='m-auto pb-5' style={{ height: '500px', width: '90%' }}>
                    <MapContainer center={[18.5615, 73.7685]} zoom={15} style={{ height: '100%', width: '100%' }}>
                        <SatelliteLayerSwitcher />
                        <MapClickHandler />

                        {clickPositions.map((pos, idx) => (
                            <Marker key={idx} position={pos}>
                                <Popup>{idx === 0 ? `${typeofConstruction} Start Point` : `${typeofConstruction} End Point`}</Popup>
                            </Marker>
                        ))}

                        {FetchedCoordinates &&
                            FetchedCoordinates.map((val, index) => (
                                <Polygon
                                    key={index}
                                    positions={val.Area}
                                    pathOptions={{ color: 'blue', weight: 2, fillOpacity: 0.8 }}
                                >
                                    <Popup>{val.ProposalID}</Popup>
                                </Polygon>
                            ))
                        }

                        {clickPositions.length === 2 && (
                            <>
                                {/* Polyline for all types */}
                                <Polyline
                                    positions={clickPositions}
                                    pathOptions={{
                                        color:
                                            typeofConstruction === "Road" ? "blue" :
                                                typeofConstruction === "Metro" ? "red" :
                                                    typeofConstruction === "Water" ? "aqua" :
                                                        "brown",
                                        weight: typeofConstruction === "Metro" ? 4 : 2,
                                        dashArray: typeofConstruction === "Metro" ? "10,10" :
                                            typeofConstruction === "Drainage" ? "2,6" :
                                                undefined
                                    }}
                                />

                                {/* Polygon for all types */}
                                <Polygon
                                    positions={polygonPositions}
                                    pathOptions={{
                                        color:
                                            typeofConstruction === "Road" ? "green" :
                                                typeofConstruction === "Metro" ? "red" :
                                                    typeofConstruction === "Water" ? "aqua" :
                                                        "brown",
                                        weight: 2,
                                        fillOpacity: 0.4,
                                        dashArray: typeofConstruction === "Drainage" ? "2,6" : undefined
                                    }}
                                >
                                    <Popup>Proposal for : {typeofConstruction} Area</Popup>
                                </Polygon>
                            </>
                        )}
                    </MapContainer>



                    <div className="col-12 text-center my-4">
                        <button className='btn btn-success px-4 mx-4' onClick={() => SubmitCoordinateSelected()}>Submit</button>
                        <button className='btn btn-danger px-4 mx-4 fw-bold' onClick={() => ResetClickPoint()}>Clear</button>
                        <button className='btn btn-danger px-4 mx-4' onClick={() => CancelMapSubmission()}>Cancel</button>
                    </div>
                </div>
            </div>






        </>
    );
}

export default Mapfunction;